import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgRoofUnselected = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 240,
	height: 44,
	fill: "none",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "#fff",
		stroke: "#EE7400",
		strokeDasharray: "11 11",
		d: "M120 .53 237.18 43.5H2.82z"
	})
});
export default SvgRoofUnselected;
